module.exports = __webpack_public_path__ + "img/第8章_1-1_高賓閣正面.jpg";